import { Connection } from '@3d-scene/model3d/connection';
import { MetaElementUsageIdentityVO } from '../../vo/meta-element.vo';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { BridgeArticleManager } from '@project/components/article/manager/bridge-article.manager';
import { ConnectionInfoService } from '@3d-scene/model3d/service/connection-info.service';

export class BaseBridgeArticlePinsOperation {
  private _connectionIdentities: MetaElementUsageIdentityVO[];

  constructor(
    connectionCubes: Connection[],
    private bridgeManager: BridgeArticleManager,
    private containerService: ContainerService,
    private connectionInfoService: ConnectionInfoService
  ) {
    this._connectionIdentities = this.getConnectionIdentities(connectionCubes);
  }

  private getConnectionIdentities(connectionCubes: Connection[]): MetaElementUsageIdentityVO[] {
    if (!connectionCubes) {
      return [];
    }
    const identities: MetaElementUsageIdentityVO[] = [];
    for (const cube of connectionCubes) {
      const articleContainer: ArticleContainer = this.containerService.getArticleContainer(cube);
      if (articleContainer) {
        identities.push(MetaElementUsageIdentityVO.create(articleContainer.articleGUID, cube.metaElementVO.name));
      }
    }
    return identities;
  }

  private getConnectionCubesByIdentities(identities: MetaElementUsageIdentityVO[]): Connection[] {
    const cubes: Connection[] = [];
    for (const identity of identities) {
      const connectionCube: Connection = this.connectionInfoService.findConnectionByIdentity(identity);
      if (connectionCube) {
        cubes.push(connectionCube);
      }
    }
    return cubes;
  }

  protected breakPins(): void {
    const connectionCubes: Connection[] = this.getConnectionCubesByIdentities(this._connectionIdentities);
    if (connectionCubes.length > 0) {
      this.bridgeManager.breakPins(connectionCubes);
    }
  }

  protected restorePins(): void {
    const connectionCubes: Connection[] = this.getConnectionCubesByIdentities(this._connectionIdentities);
    if (connectionCubes.length > 0) {
      this.bridgeManager.recoverPins(connectionCubes);
    }
  }
}
